// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__lP4tQ","overflowing":"ReadFullNote_overflowing__UDKPR"};